import { getStorage } from './getStorage'

const DATA_EXPIRATION_IN_HOURS = 24 * 7

export const paginationHelpers = (apiIdentifier: string) => {
    const storageName = `${apiIdentifier}-api-params`

    const getStoredApiParams = () => {
        const storedApiParams = getStorage(storageName)
        if (storedApiParams?.timestamp && storedApiParams?.cursor) {
            const currentTimestamp = Math.floor(Date.now() / 1000)
            const storedTimestamp = Number(storedApiParams.timestamp)
            const isExpired =
                currentTimestamp - storedTimestamp >
                DATA_EXPIRATION_IN_HOURS * 60 * 60
            if (isExpired) {
                delete storedApiParams.cursor
            }
        }
        return storedApiParams || {}
    }

    const storeCurrentTimestamp = () => {
        const currentTimestamp = Math.floor(Date.now() / 1000)
        localStorage.setItem(
            storageName,
            JSON.stringify({
                timestamp: currentTimestamp.toString()
            })
        )
    }

    const storeApiParams = (timestamp: string, cursor: string) => {
        const safeTimestamp = timestamp
            ? Math.floor(Number(timestamp)).toString()
            : undefined
        if (safeTimestamp || cursor) {
            localStorage.setItem(
                storageName,
                JSON.stringify({ timestamp: safeTimestamp, cursor })
            )
        }
    }

    return {
        getStoredApiParams,
        saveCurrentTimestamp: storeCurrentTimestamp,
        storeApiParams
    }
}
